var _svg;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This file is automatically generated from generateIllustrations.js
import * as React from 'react';
import IllustrationContainer from '../IllustrationContainer.js';

function SafeIllustration(props) {
  return /*#__PURE__*/React.createElement(IllustrationContainer, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 128 128",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M124 2H4a2 2 0 00-2 2v120a2 2 0 002 2h120a2 2 0 002-2V4a2 2 0 00-2-2z",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.305 25.801V13.305a2 2 0 012-2h101.39a2 2 0 012 2v101.39a2 2 0 01-2 2H13.305a2 2 0 01-2-2v-11.712M11.305 93.873V34.126",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M63.314 88.585c13.578 0 24.584-11.007 24.584-24.585 0-13.578-11.006-24.584-24.584-24.584S38.73 50.423 38.73 64c0 13.578 11.006 24.585 24.584 24.585z",
      fill: "#009CEB"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.434 25.8H2v8.228h15.434a2 2 0 002-2v-4.227a2 2 0 00-2-2zM17.434 93.873H2v8.228h15.434a2 2 0 002-2v-4.228a2 2 0 00-2-2z",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })))
  }));
}

export default SafeIllustration;